import { FieldDescriptor } from '../../../models/AiFeature'

export function interleaveWithSeparator<T>(items: T[], separator: T): T[] {
  if (items.length <= 1) return items
  return items.flatMap((item, index) => (index < items.length - 1 ? [item, separator] : [item]))
}

export const DEFAULT_SEPARATOR: FieldDescriptor = { value: ', ', type: 'static' }

export const toCamelCase = (str: string): string => {
  const camelCaseString = str
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) => (index === 0 ? match.toLowerCase() : match.toUpperCase()))
    .replace(/\s+/g, '')
  return camelCaseString.slice(0, 64)
}
